import { extractSegmentData } from '../../utils/utils';
import CabinUpgradeUnavailableSegmentCard from './CabinUpgradeUnavailableSegmentCard';
import CabinUpgradeAvailableSegmentCard from './CabinUpgradeAvailableSegmentCard';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const CabinUpgradeSelection = _ref => {
  let {
    availabilityTexts,
    segmentUpgradeList,
    setUnselectedCabinUpgrades,
    selectedCabinUpgradeOptions,
    unselectedCabinUpgrades,
    setSelectedCabinUpgradeOptions
  } = _ref;
  if (!(segmentUpgradeList !== null && segmentUpgradeList !== void 0 && segmentUpgradeList.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: segmentUpgradeList.map(segmentUpgrade => {
      const segmentKey = `bound-${segmentUpgrade.boundIndex}-segment-${segmentUpgrade.segmentIndex}`;
      const {
        isSegmentAvailable,
        originDestinationAirportAriaLabelText,
        flightRoute
      } = extractSegmentData(segmentUpgrade, availabilityTexts);
      return isSegmentAvailable ? /*#__PURE__*/_jsx(CabinUpgradeAvailableSegmentCard, {
        drawerTexts: availabilityTexts.drawer,
        flightRoute: flightRoute,
        originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
        segmentKey: segmentKey,
        segmentUpgrade: segmentUpgrade,
        selectedCabinUpgradeOptions: selectedCabinUpgradeOptions,
        setSelectedCabinUpgradeOptions: setSelectedCabinUpgradeOptions,
        setUnselectedCabinUpgrades: setUnselectedCabinUpgrades,
        unselectedCabinUpgrades: unselectedCabinUpgrades
      }, segmentKey) : /*#__PURE__*/_jsx(CabinUpgradeUnavailableSegmentCard, {
        availabilityCardTexts: availabilityTexts === null || availabilityTexts === void 0 ? void 0 : availabilityTexts.availabilityCard,
        flightRoute: flightRoute,
        originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText,
        segmentKey: segmentKey
      }, segmentKey);
    })
  });
};
export default CabinUpgradeSelection;
//# sourceMappingURL=CabinUpgradeSelection.js.map